import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import SpecificationGroupsTableContainer from '../../../modules/specificationGroups/components/SpecificationGroupsTableContainer';
import Button from '../../../components/buttons/Button';
import { useNavigate } from 'react-router-dom';
import UploadFile from '../../../components/buttons/UploadFile/UploadFile';
import { useQueryClient } from '@tanstack/react-query';

const SpecificationGroups = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/specs-groups',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.specification_groups'),
    withPagination: true,
    queryKey: 'specs-groups',
    customSearchPlaceholder: `${t('search_by')} ${t('name')}`
  });

  const tableHeaders = [{ label: '#' }, { label: t('name_en') }, { label: t('name_ar') }, { label: t('actions'), customClass: 'actions_col' }];

  const navigate = useNavigate();

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="accessories-page-container">
      <ListHeader customClass="table_filters">
        <div className="filter_container">{searchEle}</div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <UploadFile
            endpoint="admin/specs/import"
            onUploadSuccess={() => {
              queryClient.invalidateQueries({ queryKey: ['specs-groups'] });
            }}
          >
            {t('import_specs')}
          </UploadFile>
          <Button text={t('create_specification_group')} onClick={() => navigate('/specification-groups/create-group')} />
        </div>
      </ListHeader>
      <SpecificationGroupsTableContainer tableHeaders={tableHeaders} data={apiData?.sort((a: any, b: any) => a.id - b.id)} noDataMessage={t('no_groups_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default SpecificationGroups;
